import {useEffect, useState} from 'react';
import Image from "next/image";

import styles from '@styles/common/Message.module.scss';

function MessageComponent(props) {
	const {
		message,
		messageKey,
		itemAddedToBag = false,
		externalClass = null,
	} = props;
	const [htmlBlock, setHtmlBlock] = useState('');
	useEffect(() => {
		if (messageKey === 'error') {
			setHtmlBlock(
				<div
					className={`${styles.cupponMessage} ${styles.error} ${
						externalClass || ''
					}`}
				>
					<i>
						<div className={styles.couponImage}>
							<Image
                                src='/assets/images/error-icon-peach.svg'
                                alt='error-icon'
                                fill
                                sizes="100vw" />
						</div>
					</i>{' '}
					{message}
				</div>,
			);
		}
		if (messageKey === 'success') {
			setHtmlBlock(
				<div
					className={`${styles.cupponMessage} ${
						itemAddedToBag ? styles.itemAddedToBag : styles.success
					} ${externalClass || ''}`}
				>
					<i>
						<div className={styles.couponImage}>
							<Image
                                src='/assets/images/check-icon-white.svg'
                                alt='check-icon'
                                fill
                                sizes="100vw" />
						</div>
					</i>{' '}
					{message}
				</div>,
			);
		}
		if (messageKey === 'warning') {
			setHtmlBlock(
				<div
					className={`${styles.cupponMessage} ${styles.warning} ${
						externalClass || ''
					}`}
				>
					<i className='fas fa-exclamation-triangle'></i> {message}
				</div>,
			);
		}
		if (messageKey === 'warningOvercast') {
			setHtmlBlock(
				<div
					className={`${styles.cupponMessage} ${styles.warningOvercast} ${
						externalClass || ''
					}`}
				>
					<i className='fas fa-exclamation-triangle'></i> {message}
				</div>,
			);
		}
		if (messageKey === 'warningPeach') {
			setHtmlBlock(
				<div
					className={`${styles.cupponMessage} ${styles.warningPeach} ${
						externalClass || ''
					}`}
				>
					<i className='fas fa-exclamation-triangle'></i> {message}
				</div>,
			);
		}
		if (messageKey === 'errorText') {
			setHtmlBlock(
				<div className={`${styles.textDanger} ${externalClass || ''}`}>
					{message}
				</div>,
			);
		}
		if (messageKey === 'errorTextZero') {
			setHtmlBlock(
				<div className={`${styles.textDanger} ${externalClass || ''} p-0`}>
					{message}
				</div>,
			);
		}
		if (messageKey === 'successText') {
			setHtmlBlock(
				<div className={`${styles.textSuccess} ${externalClass || ''}`}>
					{message}
				</div>,
			);
		}
		if (messageKey === 'overcastText') {
			setHtmlBlock(
				<div className={`${styles.textOvercast} ${externalClass || ''}`}>
					{message}
				</div>,
			);
		}
		if (messageKey === 'mossText') {
			setHtmlBlock(
				<div className={`${styles.textMoss} ${externalClass || ''}`}>
					{message}
				</div>,
			);
		}
	}, [externalClass, itemAddedToBag, message, messageKey]);

	return htmlBlock;
}

export default MessageComponent;
